import Smartphones from 'Counterparties/Customers/views/CustomersView/containers/Smartphones'
import Tablets from 'Counterparties/Customers/views/CustomersView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const CustomersView = getCurrentDeviceView(Smartphones, Tablets)

export default CustomersView
